import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  return (
    <nav className="bg-gradient-to-r from-sky to-etmgreen p-4 sticky top-0 z-50">
      <div className="container mx-auto flex items-center justify-between">
        {/* Logo & Title */}
        <div className="flex items-center space-x-4">
          <img src="/images/logo.png" alt="Navoi ETM Logo" className="h-10 w-10" />
          <Link className="text-white text-xl font-bold" to="/">
            {t('siteTitle')}
          </Link>
        </div>

        <div className="hidden lg:flex items-center space-x-6">
          <ul className="flex items-center space-x-6 font-bold">
            <li>
              <Link className="text-white hover:text-gray-200" to="/">
                {t('navbar.home')}
              </Link>
            </li>
            <li>
              <Link className="text-white hover:text-gray-200" to="/Products">
                {t('navbar.products')}
              </Link>
            </li>
            <li>
              <Link className="text-white hover:text-gray-200" to="/Services">
                {t('navbar.services')}
              </Link>
            </li>
            <li>
              <Link className="text-white hover:text-gray-200" to="/About">
                {t('navbar.about')}
              </Link>
            </li>
            <li>
              <Link className="text-white hover:text-gray-200" to="/Contact">
                {t('navbar.contact')}
              </Link>
            </li>
          </ul>
         
        </div>
        <div className="flex items-center space-x-2 ml-6 hidden 1024:block">
            <button onClick={() => changeLanguage('uz')} className="text-white hover:text-gray-200">
              UZ
            </button>
            <button onClick={() => changeLanguage('ru')} className="text-white hover:text-gray-200">
              RU
            </button>
            <button onClick={() => changeLanguage('en')} className="text-white hover:text-gray-200">
              EN
            </button>
          </div>

        <button
          onClick={() => setIsOpen((prev) => !prev)}
          className="lg:hidden text-white focus:outline-none"
          aria-label="Toggle menu"
        >
          {isOpen ? (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>
      </div>

      {isOpen && (
        <div className="lg:hidden bg-white shadow-md">
          <ul className="flex flex-col">
            <li>
              <Link
                to="/"
                onClick={() => setIsOpen(false)}
                className="block px-4 py-3 text-gray-700 hover:bg-gray-100 transition"
              >
                {t('navbar.home')}
              </Link>
            </li>
            <li>
              <Link
                to="/Products"
                onClick={() => setIsOpen(false)}
                className="block px-4 py-3 text-gray-700 hover:bg-gray-100 transition"
              >
                {t('navbar.products')}
              </Link>
            </li>
            <li>
              <Link
                to="/Services"
                onClick={() => setIsOpen(false)}
                className="block px-4 py-3 text-gray-700 hover:bg-gray-100 transition"
              >
                {t('navbar.services')}
              </Link>
            </li>
            <li>
              <Link
                to="/About"
                onClick={() => setIsOpen(false)}
                className="block px-4 py-3 text-gray-700 hover:bg-gray-100 transition"
              >
                {t('navbar.about')}
              </Link>
            </li>
            <li>
              <Link
                to="/Contact"
                onClick={() => setIsOpen(false)}
                className="block px-4 py-3 text-gray-700 hover:bg-gray-100 transition"
              >
                {t('navbar.contact')}
              </Link>
            </li>
          </ul>
          <div className="flex justify-center space-x-4 py-3 border-t">
            <button
              onClick={() => changeLanguage('uz')}
              className="text-gray-700 hover:text-etmgreen"
            >
              UZ
            </button>
            <button
              onClick={() => changeLanguage('ru')}
              className="text-gray-700 hover:text-etmgreen"
            >
              RU
            </button>
            <button
              onClick={() => changeLanguage('en')}
              className="text-gray-700 hover:text-etmgreen"
            >
              EN
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
